import { render, staticRenderFns } from "./UserMenuAction.vue?vue&type=template&id=607dfa16&"
import script from "./UserMenuAction.vue?vue&type=script&lang=js&"
export * from "./UserMenuAction.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuAction.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports